/**
 * The statuses a retry treats as worth another attempt by default.
 *
 * @remarks
 * `RetryConfig.retryableStatuses` REPLACES this list rather than adding to it,
 * so a caller who wants these plus one more spreads them:
 * `[...DEFAULT_RETRYABLE_STATUSES, 418]`.
 *
 * Frozen as well as `readonly`, so a `push` throws rather than being ignored.
 * Every consumer of the library shares this one array, so without the freeze a
 * single `push` would quietly change what all the others retry.
 *
 * @privateRemarks
 * It is exported for exactly that spread -- you cannot spread what you cannot
 * name.
 *
 * The two guards stop different callers. The type stops TypeScript; the freeze
 * stops JavaScript, and TypeScript that reached the array through an `any`.
 */
export const DEFAULT_RETRYABLE_STATUSES = Object.freeze([
  408, 429, 502, 503, 504,
] as const);
